/**
 * Shared category icon + colour maps used by the Expenses tab and the
 * Add/Edit-Expense modals in GroupDetailPage. Centralised here so the
 * extracted tab components and the parent page render identical chips.
 */
import {
  Utensils,
  Car,
  Home,
  Dumbbell,
  Wine,
  CalendarDays,
  Play,
  ShoppingBag,
  Stethoscope,
  Zap,
  MoreHorizontal,
} from 'lucide-react';

export const categoryIcons = {
  food: Utensils,
  transport: Car,
  accommodation: Home,
  sports: Dumbbell,
  nightlife: Wine,
  restaurant: Utensils,
  court_booking: CalendarDays,
  entertainment: Play,
  shopping: ShoppingBag,
  groceries: ShoppingBag,
  medical: Stethoscope,
  utilities: Zap,
  miscellaneous: MoreHorizontal,
};

export const categoryColors = {
  food: 'bg-orange-500/20 text-orange-600 dark:text-orange-400',
  transport: 'bg-blue-500/20 text-blue-600 dark:text-blue-400',
  accommodation: 'bg-purple-500/20 text-purple-600 dark:text-purple-400',
  sports: 'bg-green-500/20 text-green-600 dark:text-green-400',
  nightlife: 'bg-pink-500/20 text-pink-600 dark:text-pink-400',
  restaurant: 'bg-amber-500/20 text-amber-600 dark:text-amber-400',
  court_booking: 'bg-teal-500/20 text-teal-600 dark:text-teal-400',
  entertainment: 'bg-indigo-500/20 text-indigo-600 dark:text-indigo-400',
  shopping: 'bg-rose-500/20 text-rose-600 dark:text-rose-400',
  groceries: 'bg-lime-500/20 text-lime-600 dark:text-lime-400',
  medical: 'bg-red-500/20 text-red-600 dark:text-red-400',
  utilities: 'bg-yellow-500/20 text-yellow-600 dark:text-yellow-400',
  miscellaneous: 'bg-gray-500/20 text-gray-600 dark:text-gray-400',
};
